import * as React from 'react';
import isNil from 'lodash/isNil';
import pick from 'lodash/pick';

import OfferShippingCard from 'modules/subcampaigns/components/offer-shipping-card/OfferShippingCard';
import CcmOfferCardBanner from 'modules/subcampaigns/components/ccm/offer-card-banner/CcmOfferCardBanner';
import CcmOfferBanner from 'modules/subcampaigns/components/ccm/offer-banner/CcmOfferBanner';
import CcmOfferAdditionalRequirements from 'modules/subcampaigns/components/ccm/offer-additional-requirements/CcmOfferAdditionalRequirements';
import CcmOfferLegalRequirements from 'modules/subcampaigns/components/ccm/offer-legal-requirements/CcmOfferLegalRequirements';
import CcmOfferDeliverables from 'modules/subcampaigns/components/ccm/offer-deliverables/CcmOfferDeliverables';

import './ccm-campaign-offers-detail.scss';

import type {
  Campaign,
  Deliverable,
  SubcampaignWithInfluencerSettings
} from 'types';
import type {
  CcmOfferTab
} from '../types';

type Props = {
  campaignId: number,
  campaign: Campaign | undefined,
  subcampaign: SubcampaignWithInfluencerSettings,
  deliverables: Array<Deliverable>,
  activeTab: CcmOfferTab,
  runtimeLegalRequirementsTemplate: string | null,
  outfitGuidelineLink: string,
  affiliationPerClickCost: string
};

const CcmCampaignOffersDetail: React.FC<Props> = ({
  campaignId,
  campaign,
  subcampaign,
  deliverables,
  activeTab,
  runtimeLegalRequirementsTemplate,
  outfitGuidelineLink,
  affiliationPerClickCost
}): JSX.Element | null => {
  if (isNil(campaign) || isNil(subcampaign)) {
    return null;
  }

  const legalRequirements = campaign.ccmLegalRequirementsTemplate || runtimeLegalRequirementsTemplate;

  return (
    <div className="ccm-campaign-offers-detail">
      <div className="ccm-campaign-offers-detail__offer-card-banner">
        <CcmOfferCardBanner
          campaignId={campaignId}
          subcampaign={subcampaign}
          activeTab={activeTab}
        />
      </div>
      <CcmOfferBanner
        campaign={campaign}
        affiliationPerClickCost={affiliationPerClickCost}
      />
      <div className="ccm-campaign-offers-detail__offer-shipping">
        <OfferShippingCard
          isForBrand
          subcampaignId={subcampaign.id}
          headingClass=""
          includesDelivery={Boolean(subcampaign.offer?.includesShipping)}
          shippingAddress={subcampaign.shippingAddress}
          isOfferAccepted={subcampaign.offer?.state === 'accepted'}
          influencerOrganizationSettings={pick(subcampaign, [
            'bankDetails',
            'billingAddress',
            'businessDetails',
            'proofDocuments'
          ])}
        />
      </div>
      <CcmOfferAdditionalRequirements
        campaign={campaign}
        outfitGuidelineLink={outfitGuidelineLink}
      />
      <CcmOfferLegalRequirements
        legalRequirements={legalRequirements}
      />
      <CcmOfferDeliverables
        subcampaign={subcampaign}
        deliverables={deliverables}
      />
    </div>
  );
};

export default CcmCampaignOffersDetail;
